import { useStore, State } from 'store';

const selector = (state: State) => state.authStateAsync;

export default function useAuthStateAsync() {
  return useStore(selector);
}
